import type {
    GLOBAL_STATE_CONSTANT_TYPE
} from "../types";

export const GLOBAL_STATE_CONSTANT: GLOBAL_STATE_CONSTANT_TYPE = {
    isAppReady: false,
    isGuest: true,
    user: null
};
